// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__4bEzz","title":"Images90_title__ZFiya","images":"Images90_images__XlGlV"};